/**
 * Asynchronously loads the component for MarketPage
 */

import { lazyLoad } from "@utils/loadable";

export const MarketPage = lazyLoad(
  () => import("./index"),
  (module) => module.MarketPage
);
